<template>
    <Modal v-model="show"
        title="现售送货单质检"
        :width="1200"
        :footer-hide="true"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top">

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="定单编号">
                            <Input :value="curSaleDeliveryRecord.curSaleOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员名称">
                            <Input :value="curSaleDeliveryRecord.curSaleRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="curSaleDeliveryRecord.curSaleRecordOwnerPhone"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货单编号">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货总量">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordTotalQuantity"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货日期">
                            <Input :value="formatDateString(curSaleDeliveryRecord.curSaleDeliveryRecordDeliveryDate)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                    </Row>

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="物流公司">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordLogisticsCompanyName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="8">
                        <FormItem label="备注">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordRemark"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(curSaleDeliveryRecord.curSaleDeliveryRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="curSaleDeliveryRecord.curSaleDeliveryRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="质检图片">
                            <image-cut v-model="uploadImageFile"
                                button-type="warning" />
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="productTable"
                            size="small"
                            :columns="productTable.columns"
                            :data="curSaleDeliveryDetails"
                            highlight-row
                            stripe
                            border />
                        </Col>
                    </Row>

                    <Row :gutter="16"
                        class="row-margin-top-10"
                        style="margin-top:10px;text-align:right;">
                        <Col v-if="curSaleDeliveryRecord.curSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK"
                            span="24">
                        <Button type="primary"
                            @click="onSubmit">质检提交</Button>
                        </Col>
                    </Row>

                </Form>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import DecimalInput from '@/components/number-input/decimal-input';
import ImageCut from '@/components/image-cut/ImageCut';
import { CHECK_STATUS_TYPE_UN_CHECK } from '@/view/distributionStation-management/distributionStation-delivery-check/DistributionStationDeliveryCheckType';

import { getCurSaleDeliveryRecord } from '@/api/modules/curSale-management/curSale-delivery';
import { saveDistributionStationCurSaleDeliveryCheck } from '@/api/modules/distributionStation-management/distributionStation-delivery-check';

export default {
    name: 'CurDistributionStationDeliveryCheckEdit',
    components: {
        ImageCut
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            recordUuid: '',
            CHECK_STATUS_TYPE_UN_CHECK,
            curSaleDeliveryRecordUuid: '',
            curSaleDeliveryRecord: {
                curSaleOrderRecordCode: '',
                curSaleDeliveryRecordCode: '',
                curSaleDeliveryRecordTotalQuantity: 0,
                curSaleDeliveryRecordDeliveryDate: '',
                curSaleDeliveryRecordCreateAt: '',
                curSaleDeliveryRecordOwnerName: '',
                curSaleDeliveryRecordLogisticsCompanyName: '',
                curSaleDeliveryRecordRemark: '',
                curSaleDeliveryRecordDistributionStationCheckStatus: ''
            },
            curSaleDeliveryDetails: [],
            productTable: {
                columns: [
                    { title: '产品编码', key: 'curSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'curSaleOrderDetailProductName', align: 'center' },
                    { title: '单位', key: 'curSaleOrderDetailProductUnit', align: 'center' },
                    { title: '下单量', key: 'curSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '送货量', key: 'curSaleDeliveryDetailQuantity', align: 'center' },
                    { title: '转运站收货量', key: 'curSaleDeliveryDetailConfirmQuantity', align: 'center' },
                    {
                        title: '质量问题',
                        key: 'qualifyFailQuantity',
                        align: 'center',
                        render: (h, params) => {
                            if (this.curSaleDeliveryRecord.curSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.qualifyFailQuantity,
                                        max: params.row.curSaleDeliveryDetailQuantity,
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.curSaleDeliveryDetails[params.index].qualifyFailQuantity = newVal;
                                            this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailConfirmQuantity
                                                = this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailQuantity
                                                - this.curSaleDeliveryDetails[params.index].qualifyFailQuantity
                                                - this.curSaleDeliveryDetails[params.index].logisticsFailQuantity;
                                        }
                                    }
                                });
                            }
                            else {
                                this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailConfirmQuantity
                                    = this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailQuantity
                                    - this.curSaleDeliveryDetails[params.index].distributionStationProductCheckJournalQualifyFailQuantity
                                    - this.curSaleDeliveryDetails[params.index].distributionStationProductCheckJournalLogisticsFailQuantity;
                                return h('div', [
                                    h('span', params.row.distributionStationProductCheckJournalQualifyFailQuantity)
                                ]);
                            }
                        }
                    },
                    {
                        title: '物流责任',
                        key: 'logisticsFailQuantity',
                        align: 'center',
                        render: (h, params) => {
                            if (this.curSaleDeliveryRecord.curSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.logisticsFailQuantity,
                                        max: params.row.curSaleDeliveryDetailQuantity,
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.curSaleDeliveryDetails[params.index].logisticsFailQuantity = newVal;
                                            this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailConfirmQuantity
                                                = this.curSaleDeliveryDetails[params.index].curSaleDeliveryDetailQuantity
                                                - this.curSaleDeliveryDetails[params.index].qualifyFailQuantity
                                                - this.curSaleDeliveryDetails[params.index].logisticsFailQuantity;
                                        }
                                    }
                                });
                            }
                            else {
                                return h('div', [
                                    h('span', params.row.distributionStationProductCheckJournalLogisticsFailQuantity)
                                ]);
                            }
                        }
                    },
                    {
                        title: '原因',
                        key: 'remark',
                        align: 'center',
                        render: (h, params) => {
                            if (this.curSaleDeliveryRecord.curSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK) {
                                return h('Input', {
                                    props: {

                                    },
                                    on: {
                                        'on-change': newVal => {
                                            this.curSaleDeliveryDetails[params.index].remark = newVal.target.value;
                                        }
                                    }
                                });
                            }
                            else {
                                return h('div', [
                                    h('span', params.row.distributionStationProductCheckJournalRemark)
                                ]);
                            }
                        }
                    }
                ]
            },
            uploadImageFile: ''
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(recordUuid) {
            this.recordUuid = recordUuid;
            this.show = true;
        },
        init() {
            // const query = this.$route.query;
            if (this.recordUuid) {
                this.curSaleDeliveryRecordUuid = this.recordUuid;

                this.innerSpin = true;
                getCurSaleDeliveryRecord(this.curSaleDeliveryRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.curSaleDeliveryRecord = Object.assign(this.curSaleDeliveryRecord, res.data.curSaleDeliveryRecord);
                        this.curSaleDeliveryDetails = res.data.curSaleDeliveryDetails.map(item => {
                            return Object.assign(item, {
                                qualifyFailQuantity: 0,
                                logisticsFailQuantity: 0,
                                curSaleDeliveryDetailConfirmQuantity: item.curSaleDeliveryDetailQuantity,
                                remark: ''
                            });
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        formatDateString,
        formatDateTimeString,
        onSubmit() {
            const hasUnqualifiedQuantity = this.curSaleDeliveryDetails.find(item => item.qualifyFailQuantity > 0);
            if (hasUnqualifiedQuantity) {
                this.$Modal.confirm({
                    title: '有质检不合格的产品，确认提交？',
                    onOk: () => {
                        this.actSubmit();
                    }
                });
            }
            else {
                this.actSubmit();
            }
        },
        actSubmit() {
            const submitData = {
                curSaleDeliveryRecordUuid: this.curSaleDeliveryRecordUuid,
                checkItems: this.curSaleDeliveryDetails.map(item => {
                    return {
                        curSaleDeliveryDetailUuid: item.curSaleDeliveryDetailUuid,
                        qualifyFailQuantity: item.qualifyFailQuantity,
                        logisticsFailQuantity: item.logisticsFailQuantity,
                        remark: item.remark
                    };
                }),
                checkImage: this.uploadImageFile
            };

            this.innerSpin = true;
            saveDistributionStationCurSaleDeliveryCheck(submitData).then(res => {
                this.innerSpin = false;

                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
